module.exports = __webpack_public_path__ + "img/result-detail-sacrifice-inright03.3feddce9.svg";